<template>
<div id="contenedor-agregar-nuevo-catalogo-expediente">
    <v-form ref="agregarNuevoCatalogoExpediente" v-model="esformularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar Nuevo Catálogo Expediente
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-area
          v-model="expedienteDocumento.descripcion"
          label="Descripción"
          :rules="[mixReglas.requerido]"
          required>
          </custom-text-area>
          <custom-text-field
          v-model="expedienteDocumento.modulo"
          label="Módulo"
          :rules="[mixReglas.requerido]"
          required>
          </custom-text-field>
          <v-row>
            <custom-text-field
            v-model="expedienteDocumento.normatividad"
            label="Normatividad">
          </custom-text-field>
          </v-row>
          <v-row align="center">
            <custom-select
              cols="4"
              v-model="expedienteDocumento.etapa"
              label="Estapa"
              :items="itemsEtapa"
              item-text="etapa"
              item-value="valor"
              :rules="[mixReglas.requerido]"
              required>
            </custom-select>
            <custom-text-field
              cols="4"
              v-model.number="expedienteDocumento.orden"
              type="number"
              label="Orden"
              :rules="[mixReglas.requerido]"
              required>
            </custom-text-field>
            <v-switch
              cols="4"
              v-model="expedienteDocumento.seRepite"
              label="¿El documento se repite?"
              inset>
            </v-switch>
          </v-row>
          <v-card-title class="secondary--text">¿En que aplica este documento?</v-card-title>
          <v-row justify="center">
            <v-switch class="mx-4"
              cols="2"
              v-model="expedienteDocumento.esObra"
              label="Obra"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="2"
              v-model="expedienteDocumento.esServicio"
              label="Servicio"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="2"
              v-model="expedienteDocumento.esLicitacionPublica"
              label="Licitación Pública"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="2"
              v-model="expedienteDocumento.esLicitacionSimplificada"
              label="Licitación Simplificada"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="2"
              v-model="expedienteDocumento.esAdjudicacionDirecta"
              label="Adjudicación Directa"
              inset>
            </v-switch>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarCatalogoExpediente"
            :disabled="!esformularioValido || enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
</div>
</template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
// import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixCatalogoExpedientes from './mixCatalogoExpedientes';

export default {
  name: 'AgregarNuevoCatalogoExpediente',
  mixins: [mixCatalogoExpedientes],
  components: {
    CustomTextField,
    CustomSelect,
    CustomButton,
    CustomTextArea,
  },
  data() {
    return {
      esformularioValido: false,
      enviandoFormulario: false,
      itemsEtapa: [
        { etapa: 'AE', valor: 1 },
        { etapa: 'EJ', valor: 2 },
        { etapa: 'DE', valor: 3 },
      ],
      expedienteDocumento: {
        descripcion: '',
        etapa: null, // AE (antes ejecucions), EJ(Ejecucion), DE (Despues de Ejecucion)
        seRepite: false,
        modulo: '',
        esObra: false,
        esServicio: false,
        esLicitacionPublica: false,
        esLicitacionSimplificada: false,
        esAdjudicacionDirecta: false,
        orden: 0,
        normatividad: '',
      },

    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.agregarNuevoCatalogoExpediente.reset();
    },
  },
};
</script>

<style>

</style>
